// extracted by mini-css-extract-plugin
export default {"root":"NumberScaleFilterPopup_root__WxRy2"};